export const PROBLEM_WITH_REQUEST = 'There was a problem with your request';
